import { render, staticRenderFns } from "./ticket-open-alternate.vue?vue&type=template&id=68a8077a&scoped=true&"
import script from "./ticket-open-alternate.vue?vue&type=script&lang=js&"
export * from "./ticket-open-alternate.vue?vue&type=script&lang=js&"
import style0 from "./ticket-open-alternate.vue?vue&type=style&index=0&id=68a8077a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a8077a",
  null
  
)

export default component.exports